import { IDataDefinition } from "../Data/Definitions/IDataDefinition";
import { BooleanDataDefinition } from "../Data/Definitions/BooleanDataDefinition";
import { BaseExecutable } from "./BaseExecutable";
import { DataDefinitionUtilities } from "../DataDefinitionUtilities";
import { ITestingContext } from "../Testing/ITestingContext";
import { ExecutionData } from "../Data/ExecutionData/ExecutionData";
import type { AppGlueAny } from "../AppGlueAny";

export abstract class RuleExecutable extends BaseExecutable {
    protected _executionResult?: IDataDefinition | (() => IDataDefinition);

    get executionResult(): IDataDefinition | (() => IDataDefinition) {
        return this._executionResult!;
    }

    set executionResult(value: IDataDefinition | (() => IDataDefinition)) {
        this._executionResult = value;
    }

    get canChangeOutputs(): boolean {
        return !this._executionResult || !(this._executionResult instanceof Function);
    }

    abstract run(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny;

    getRuleResult(): IDataDefinition {
        if (!this._executionResult) {
            return new BooleanDataDefinition();
        }

        if (this._executionResult instanceof Function) return this._executionResult();
        else return this._executionResult;
    }

    getStorageData(): object {
        let data = super.getStorageData();

        if (this._executionResult && !(typeof this._executionResult === "function")) {
            Reflect.set(data, "executionResult", this.getRuleResult().getStorageData());
        }

        return data;
    }

    setStorageData(data: object) {
        super.setStorageData(data);

        let resultData = Reflect.get(data, "executionResult");

        if (resultData) {
            this._executionResult = DataDefinitionUtilities.getDataDefinitionFromData(resultData);
        }
    }
}
